import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { to: "/politique-de-confidentialite", label: "Confidentialité" },
    { to: "/conditions-utilisation", label: "Conditions" },
    { to: "/#support", label: "Support" },
  ];

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/70 border-b border-neutral-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_lift-minimal/artifacts/j1888ons_Logo%20-%20Lift%20AI.jpg"
            alt="Lift AI"
            className="w-8 h-8 rounded-lg object-cover"
          />
          <span className="font-semibold tracking-tight text-neutral-950">
            Lift AI
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm text-neutral-600 hover:text-neutral-950 transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <Link
          to="/#telecharger"
          data-testid="header-cta"
          className="hidden md:inline-flex items-center gap-2 bg-neutral-950 text-white text-sm font-medium px-4 py-2 rounded-full hover:bg-violet-600 transition-colors"
        >
          Télécharger
        </Link>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-neutral-950"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-neutral-200 px-6 py-6 flex flex-col gap-4"
        >
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="text-base text-neutral-700"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/#telecharger"
            onClick={() => setOpen(false)}
            className="bg-neutral-950 text-white text-sm font-medium px-4 py-2.5 rounded-full text-center"
          >
            Télécharger
          </Link>
        </div>
      )}
    </header>
  );
}
